import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Download } from 'lucide-react';

const Hero = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('qualification-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1644079446600-219068676743"
          alt="Warehouse logistics"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-gray-900/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Track Every Returnable Asset —<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-red-600">
            On Campus and Beyond
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
          E2 network + optional GPS for complete visibility of your reusable crates, pallets, containers, and equipment
        </p>

        {/* Value Bullets */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12 max-w-5xl mx-auto">
          {[
            'No SIM cards or subscriptions',
            'Real-time on-site tracking',
            'Inter-site visibility',
            'Optional GPS for off-campus',
          ].map((bullet, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3 border border-white/20">
              <p className="text-white font-medium text-sm">{bullet}</p>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            size="lg" 
            onClick={scrollToForm}
            className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
          >
            Book a Demo
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          
          <Button 
            size="lg" 
            variant="outline"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 hover:bg-white/20 px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-300"
          >
            <Download className="mr-2 w-5 h-5" />
            Download Technical Overview
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
